module.exports = __webpack_public_path__ + "img/redpoint.53de4963.png";